export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/instruments')
    },

    async add(form) {
        return await $axios.post('/instruments', form)
    },

    async update(instrument_id, form) {
        return await $axios.put(`/instruments/${instrument_id}`, form)
    },

    async remove(instrument_id) {
        return await $axios.delete(`/instruments/${instrument_id}`)
    },

    async requestForDelete(instrument_id) {
        return await $axios.post(`/instruments/${instrument_id}/markToRemove`)
    },
})
